'use client';

import { useQueryState } from 'nuqs';

export function useSearchDialogState() {
  const [isOpen, setIsOpen] = useQueryState('search', {
    parse: (value): boolean => value === 'true',
    defaultValue: false,
  });

  return { isOpen, setIsOpen };
}
